import { useMemo } from 'react';
import { Props as ReactApexChartProps } from 'react-apexcharts';
import { LangType } from '../../../../../../helpers/lang';
import { useLang } from '../../../../../../hooks/use-lang';
import { useDashboardStore } from '../../../../../../store/use-dashboard-store';
import { ChartProps } from '../../dashboard-components/dashboard-charts/use-dashboard-charts';

interface DataType {
  counts: number[];
  type: LangType[];
}

export const useReviewsDistribution = (): ChartProps => {
  const { t, getLocale } = useLang();
  const { list } = useDashboardStore();
  const data = list?.feedbacks_by_category as DataType;

  const chartData = useMemo<ReactApexChartProps>(() => {
    if (data) {
      const labels = data.type.map((item) => getLocale(item)) as string[];

      return {
        series: data.counts.some((item) => item > 0) ? data.counts : [],
        options: {
          chart: {
            type: 'donut',
            zoom: { enabled: false },
            toolbar: {
              show: false,
            },
          },
          labels,
          colors: ['#28A745', '#FFC107', '#DC3545'],
          plotOptions: {
            pie: {
              donut: {
                size: '65%',
                labels: {
                  show: true,
                  total: {
                    show: true,
                    label: t('Отзывы'),
                    formatter: () => `${data.counts.reduce((a, b) => a + b, 0)}`,
                  },
                },
              },
            },
          },
          dataLabels: {
            enabled: false,
          },
          legend: {
            position: 'right',
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            formatter: (seriesName: string, opts: any) => {
              return `${seriesName} (${opts.w.globals.series[opts.seriesIndex]})`;
            },
          },
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200,
                },
                legend: {
                  position: 'bottom',
                },
              },
            },
          ],
        },
      };
    }

    return {
      series: [],
      options: {},
    };
  }, [data, t]);

  return {
    label: 'Распределение отзывов по категориям',
    subLabel:
      'Отчёт показывает, как соотносятся отзывы разных категорий, упрощая определение основных достоинств и недостатков',
    type: 'donut',
    ...chartData,
  };
};
